import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { ExamcompassClient } from '../Api/api';
import Checked from '../UI/Checked';
// import { ExamCompassContext } from '../Context/context';

const ConfirmPayment: React.FC = () => {
  const [confirmed, setConfirmed] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const queryString = location.search.substring(1); // Remove the leading '?'
  const params = new URLSearchParams(queryString);

  // Extract parameters
  const sub_ref: string = params.get('sub_ref') || '';
  const subject: string | null = params.get('subject') || null;

  useEffect(() => {
    const confirmPayment = async () => {
      const details = {
        sub_ref: sub_ref,
        ...(subject ? { subject } : {}),
      };

      try {
        await ExamcompassClient.post('/pay/confirm_payment/', details);
        setConfirmed(true);
        localStorage.getItem('authToken') ||
          sessionStorage.getItem('authToken');
        navigate('/');
      } catch (err) {
        console.log('Could not confirm payment', err);
      }
    };

    confirmPayment();
  }, [sub_ref, subject, navigate]);
  return (
    <div className='w-full h-[100vh] flex items-center justify-center'>
      {confirmed && <Checked />}
    </div>
  );
};

export default ConfirmPayment;
